

export default class PushMessageTranslationsRequest  {
	Text?: string = '';
	Title?: string = '';
	LangCode?: string = '';
	constructor(obj?: Partial<PushMessageTranslationsRequest>) {
		if (obj) {
			Object.assign(this, obj);
		}
	}
}
